import type { IconFieldDesignTokens, IconFieldTokenSections } from '@openng/optimus-ui-themes/types/iconfield';

export const icon: IconFieldTokenSections.Icon = {
    color: '{form.field.icon.color}'
};

export default {
    icon
} satisfies IconFieldDesignTokens;
